import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { TimeFormatter } from '../../../Formatters';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const TransactionTimePropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{TimeFormatter(data.value)}</Col>
      </Row>
  ),
  id: 'transactionTimePropertyPlugin',
  title: 'Transaction Time Property',
  description: 'Transaction Time Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Transaction Time',
        },
      },
      required: ['label'],
    },
  },
};

export default TransactionTimePropertyPlugin;